module.exports = __webpack_public_path__ + "static/media/VGS_Phone_04.bc5d08f6.png";